export default __webpack_public_path__ + "static/media/svg-1.198c8835.svg";